import _ from 'lodash'


export const deserializeGeneric = item => {
  return {
    id: _.parseInt(item.id, 10),
    ...item.attributes,
    relationships: item.relationships,
  }
}


export const deserializeRelationship = (relationship, included, f=deserializeGeneric) => {
  if ( ! _.isFunction(f) || ! _.get(relationship, 'data', false) || ! included) {
    return null
  }

  if (_.isArray(relationship.data)) {
    return _.map(
      relationship.data,
      el => {
        let e = _.find(included, {
          id: _.parseInt(el.id, 10),
          type: el.type,
        })
        if ( ! e) {
          e = _.find(included, {
            id: el.id,
            type: el.type,
          })
        }
        return e ? f(e, included) : {}
      }
    )
  } else {
    let el = _.find(included, {
      id: _.chain(relationship).get('data.id', false).parseInt(10).value(),
      type: _.get(relationship, 'data.type', false),
    })
    if ( ! el) {
      el = _.find(included, {
        id: _.get(relationship, 'data.id', false),
        type: _.get(relationship, 'data.type', false),
      })
    }
    return el ? f(el, included) : {}
  }
}
